<style lang="scss" scoped>
.warn-panel {
  width: 826px;
  height: 51px;
  padding-left: 20px;
  position: relative;
  background: linear-gradient(
      180deg,
      rgba(175, 175, 175, 0.2) -28.69%,
      rgba(175, 175, 175, 0) 100%
    ),
    radial-gradient(
      247.03% 229.51% at 50% 200.82%,
      rgba(23, 61, 90, 0.119) 0%,
      rgba(4, 28, 48, 0.7) 100%
    );
  clip-path: polygon(11px 0, 826px 0, 826px 51px, 0px 51px, 0 41px, 0px 7px);
  .img {
    pointer-events: none;
    position: absolute;
    left: 0;
    z-index: 2;
  }
  .img1 {
    top: 0;
  }
  .img2 {
    bottom: 0;
  }
  .content {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    .line {
      width: 1px;
      height: 45px;
      background-color: rgba(255, 255, 255, 0.5);
    }
    .title {
      flex-shrink: 0;
      width: 153px;
      display: flex;
      .icon {
        width: 30px;
        height: 30px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .name {
        font-weight: 500;
        font-size: 18px;
        line-height: 27px;
        color: #ffffff;
        margin-left: 10px;
      }
    }
    .time-content {
      width: 173px;
      flex-shrink: 0;
      text-align: center;
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      color: #ffffff;
    }
    .message-content {
      flex-grow: 1;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      margin-left: 20px;
      color: #ffffff;
    }
  }
}
.disposeClass {
  height: 71px;
  clip-path: polygon(11px 0, 826px 0, 826px 71px, 0px 71px, 0 61px, 0px 7px);
  background: linear-gradient(
      180deg,
      rgba(241, 128, 47, 0.1) -28.69%,
      rgba(255, 255, 255, 0) 100%
    ),
    radial-gradient(
      247.03% 229.51% at 50% 200.82%,
      rgba(241, 128, 47, 0.119) 0%,
      rgba(241, 128, 47, 0.7) 100%
    );
}
</style>

<template>
  <div
    @pointerdown="click(floor)"
    class="warn-panel"
    :class="{ disposeClass: !isDispose }"
  >
    <img class="img img1" src="@/assets/public/left-back.png" alt="" />
    <img class="img img2" src="@/assets/public/left-bottom.png" alt="" />
    <div class="content">
      <div class="title">
        <div class="icon">
          <img :src="panelIcon" alt="" />
        </div>
        <div class="name">{{ panelModel }}</div>
      </div>
      <div class="line"></div>
      <div class="time-content">{{ warnTime }}</div>
      <div class="line"></div>
      <div class="message-content">{{ warnMessage }}</div>
    </div>
  </div>
</template>

<script>
import bus from "@/components/three-scene/Bus.js";

export default {
  name: "alarm-panel",
  props: {
    panelIcon: String,
    panelModel: String,
    warnTime: String,
    warnMessage: String,
    floor: Object,
    isDispose: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      headerMap: {
        "01": "A1",
        "02": "A2",
        "03": "B1B2",
        "04": "B3",
        "05": "A区地下室",
        "06": "B区地下室",
      },
      map: {
        XF: ["fourth-fourth", "烟感"], //设备运维-消防
        HJ: ["second", "室内空气"], //环境监测
        WM: ["third-first", "水表"], //能耗管理-水能耗
        KT: ["fourth-sixth", "水空调"], //设备运维-空调
        WG: ["fourth-eighth", "网关"], //设备运维-网关
        GD: ["third-third", "电表"], //能耗管理-电能耗
        SB: ["fourth-second"], //设备运维-给排水
        AF: ["first"], //监控中心
        DT: ["fourth-seventh"], //电梯
        PS: ["second"],
      },
    };
  },
  methods: {
    // 点击告警跳转路由
    async click(e) {
      console.log(e);
      if (!e.floor || !e.buildNo || !e.eqpCode) return;
      // GD供电判断
      if (e.content.includes("变电所") || e.content.includes("A#")) {
        await this.$router.push({ name: "fourth-first" });
        this.PD(e);
      } else {
        if (this.map[e.module].length != 1) {
          await this.$router.push({ name: this.map[e.module][0] });
          bus.emit("showFloorPoint", this.map[e.module][1]);
          this.PD(e);
        } else if (e.module.includes("DT")) {
          // 电梯间处理
          await this.$router.push({ name: this.map[e.module][0] });
          bus.emit("elevator", this.headerMap[e.buildNo],e.eqpCode);
        } else {
          await this.$router.push({ name: this.map[e.module][0] });
          this.PD(e);
        }
      }
    },
    // 判断地上地下
    PD(e) {
      // 地下
      if (e.floor.includes("B")) {
        if (e.eqpCode.includes("06-B01")) {
          // 跳转至配电间B
          if (e.content.includes("变电所") || e.content.includes("A#")) {
            bus.emit("qieHuan", "PDJ_D");
            bus.emit("chooseParkingPoint", e.eqpCode, "告警中心");
            bus.emit("substationData", e.eqpCode);
          } else {
            // 跳转至能耗管理
            bus.emit("chooseParkingPoint", e.eqpCode, "告警中心");
          }
        } else {
          // 跳转至配电间A
          if (e.content.includes("变电所") || e.content.includes("A#")) {
            bus.emit("qieHuan", "PDJ_A");
            bus.emit("chooseParkingPoint", e.eqpCode, "告警中心");
            bus.emit("substationData", e.eqpCode);
          } else {
            bus.emit("chooseParkingPoint", e.eqpCode, "告警中心");
          }
        }
      } else if (e.buildNo.includes("07")) {
        bus.emit(
          "chooseGround",e.eqpCode,
        );
      } else {
        // 地上
        bus.emit(
          "chooseFloorPoint",
          this.headerMap[e.buildNo],
          this.changeFloor(e.floor),
          e.eqpCode,
          "能耗"
        );
      }
    },
    changeFloor(value) {
      if (value.includes("A")) {
        return "F" + value.slice(2);
      }
      if (value.includes("B")) {
        return "-" + "F" + value.slice(2);
      }
    },
  },
};
</script>
